import axios from 'axios';
import get from 'lodash/get';
import { getJwtToken } from '../../services/auth';
import { env } from '../../config/env';

import { Amplify } from '@aws-amplify/core';
import config from '../../config';

Amplify.configure(config);

const axiosConfig = axios.create({
 baseURL: `${process.env.REACT_APP_LIMITS_API_BASE_URL}`,
 //baseURL: 'http://localhost:8000/v1',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: getJwtToken(),
  },
});

const handleErroredResponse = async (error) => {
  const originalRequest = get(error, ['response', 'config'], undefined);
  const statusCode = get(error, ['response', 'status'], undefined);
  const errMessage = get(error, ['response', 'data', 'name'], undefined);
  const errData = get(error, ['response', 'data'], undefined);

  if (statusCode === 401) {
    if (errMessage === 'TokenExpiredError') {
      const token = await getJwtToken();
      if (token) {
        axios.defaults.headers.common['Authorization'] = token;
      }
      return axiosConfig(originalRequest);
    }
  }

  if (errData) {
    return Promise.reject(errData);
  }
  return Promise.reject(error.message);
};

axiosConfig.interceptors.request.use(async (config) => {
  const aConfig = config;
  const authToken = await getJwtToken();
  if (authToken) {
    aConfig.headers["Authorization"] = authToken;
  }
  return aConfig;
}, error => Promise.reject(error));

axiosConfig.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return await handleErroredResponse(error);
  }
);

// Create a separate axios instance for the new report generation API (v2)
const axiosConfigV2 = axios.create({
  baseURL: env.NEW_REPORT_GENERATION_API_BASE_URL || `${process.env.REACT_APP_LIMITS_API_BASE_URL}`.replace('/v1', '/v2'),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: getJwtToken(),
  },
});

// Apply the same interceptors to v2 config
axiosConfigV2.interceptors.request.use(async (config) => {
  const aConfig = config;
  const authToken = await getJwtToken();
  if (authToken) {
    aConfig.headers["Authorization"] = authToken;
  }
  return aConfig;
}, error => Promise.reject(error));

axiosConfigV2.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return await handleErroredResponse(error);
  }
);

export default axiosConfig;
export { axiosConfigV2 }; 